/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Deck_Locked_PlayingInputs */



/**
* | output |
* | --- |
* | "Cannot modify deck while tournament is in progress" |
*
* @param {Err_Tournament_Deck_Locked_PlayingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_deck_locked_playing = /** @type {((inputs?: Err_Tournament_Deck_Locked_PlayingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Deck_Locked_PlayingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de modifier le deck pendant le tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se puede modificar el mazo mientras el torneo está en progreso")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível modificar o deck enquanto o torneio está em andamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile modificare il deck mentre il torneo è in corso")
	return /** @type {LocalizedString} */ ("Cannot modify deck while tournament is in progress")
});